// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"a10f1577","66":"9ae7d5ec","626":"4c68a991","667":"8d5de962","739":"94ade9a8"}[chunkId] + ".chunk.js";
};